module.exports = __webpack_public_path__ + "media/images/featured-products/supermodeller-680e75a888e7627ea9c8ecc554f7ab93.svg";